/*
 * Sets initial filter values from query parameters
 */
const setInitialValues = () => {
  const queryParams = new URLSearchParams(window.location.search)

  const legId = queryParams.get('legId')
  const govId = queryParams.get('govId')

  legId && setSelectElement('legsislation', legId)
  govId && setSelectElement('governmentAgency', govId)

  updateBlockListVisibility()
}

/*
 * Toggles operational conditions ("Operativa förutsättningar")
 */
const toggleOperationalConditions = () => {
  const parent = document.querySelector('.operational-conditions')
  const toggle = document.querySelector('.operational-conditions__toggle')

  toggle?.addEventListener('click', () => parent?.classList.toggle('expanded'))
}

/*
 * Triggers filter on select change
 */
const goalsAndActivitiesPageFilter = () => {
  const legislationSelect = document.getElementById('legsislation')
  const agencySelect = document.getElementById('governmentAgency')

  legislationSelect?.addEventListener('change', (e) => {
    setQueryParams('legId', (e.target as HTMLSelectElement).value)
    updateBlockListVisibility()
  })

  agencySelect?.addEventListener('change', (e) => {
    setQueryParams('govId', (e.target as HTMLSelectElement).value)
    updateBlockListVisibility()
  })
}

/*
 * Expanding and minimizing cards in the list
 */
const goalsAndActivitiesBlock = () => {
  document.querySelectorAll('.goal-and-activity-block .expand').forEach((block) => {
    block.addEventListener('click', expandBlock)
  })

  document.querySelectorAll('.goal-and-activity-block .minimize').forEach((block) => {
    block.addEventListener('click', minimizeBlock)
  })
}

const updateBlockListVisibility = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const govId = Number(urlParams.get('govId') ?? 0)
  const legId = Number(urlParams.get('legId') ?? 0)

  const state = { govId, legId }

  const blockList = document.querySelectorAll('.goal-and-activity-block') as NodeListOf<HTMLElement>
  const emptyResult = document.querySelector('.emptyResult') as HTMLElement | null

  let noResult = true

  for (const block of blockList) {
    if (shouldBeVisible(block, state)) {
      noResult = false
      block.style.display = 'block'
    } else {
      block.style.display = 'none'
    }
  }

  if (emptyResult) {
    emptyResult.style.display = noResult ? 'block' : 'none'
  }
}

const expandBlock = (e: Event) => {
  const currentBlock = (e.target as HTMLElement).closest('.goal-and-activity-block')
  const expandedContent = currentBlock?.querySelector('.expanded-content')
  const preview = currentBlock?.querySelector('.preview')

  if (preview instanceof HTMLElement) {
    preview.style.display = 'none'
  }

  if (expandedContent instanceof HTMLElement) {
    expandedContent.style.display = 'block'
    setTimeout(() => {
      expandedContent.classList.add('show')
    }, 50)
  }
}

const minimizeBlock = (e: Event) => {
  const currentBlock = (e.target as HTMLElement).closest('.goal-and-activity-block')
  const expandedContent = currentBlock?.querySelector('.expanded-content')
  const preview = currentBlock?.querySelector('.preview')

  if (preview instanceof HTMLElement && expandedContent instanceof HTMLElement) {
    expandedContent.classList.remove('show')
    setTimeout(() => {
      expandedContent.style.display = 'none'
      preview.style.display = 'block'
    }, 400)
  }
}

const shouldBeVisible = (element: HTMLElement, { govId, legId }: { govId: number; legId: number }) => {
  let visible = true

  const elementGovId = element.getAttribute('data-agency')?.split(' ')
  const elementLegId = element.getAttribute('data-legislation')

  if (!!govId && elementGovId && elementGovId.indexOf(String(govId)) < 0) {
    visible = false
  }
  if (!!legId && String(legId) !== elementLegId) {
    visible = false
  }

  return visible
}

const setQueryParams = (param: 'govId' | 'legId', value: string) => {
  const queryParams = new URLSearchParams(window.location.search)
  !!value ? queryParams.set(param, value) : queryParams.delete(param)

  const refresh =
    window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString()
  window.history.pushState({ path: refresh }, '', refresh)
}

const setSelectElement = (id: 'legsislation' | 'governmentAgency', value: string) => {
  const element = document.getElementById(id) as HTMLSelectElement
  element.value = value
}

goalsAndActivitiesBlock()
toggleOperationalConditions()
goalsAndActivitiesPageFilter()
setInitialValues()
